module.exports = __webpack_public_path__ + "images/118_320.jpg";